
import React, { Component, useEffect, useState } from 'react'
import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, Radio, RadioGroup } from '@mui/material';
import { connect, useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import { submitHBLFormDAta } from '../../Redux/actions/payment';
import { toast } from 'react-toastify';
import jwtDecode from 'jwt-decode';
import { useLocation } from 'react-router-dom';
import { MobilecardDetails } from '../../Redux';
import { useTranslation } from 'react-i18next';

function WebViewLoader() {
    return (
        <div className='flex justify-content-center items-center' style={{ height: '100vh' }}>
            <CircularProgress 
                size="5rem"
                className='view-loader'
            />
        </div>
    )
}

function MobileCardPayment(props: any) {
    const hblFormData = useSelector((state: any) => state.payment.hblFormData);
    const cardTokens = useSelector((state: any) => state.customer.mobilecardDetails);
    const [temp_order_id, setTempOrderID] = useState("");
    const [isNewCard, setIsNewCard] = useState(false);
    const [customer_token, setCustomerToken] = useState("")
    const [tokenId, setTokenId] = useState("")
    const [isSaveCard, setIsSaveCard] = useState(false);
    const [CustomercardToken, setCustomercardToken] = useState({} as any);
    const [card_number, setCardNum] = useState("")
    const [cardError2, setCardError2] = useState(false)
    const [cvn, setCVN] = useState("")
    const [card_expiry_month, setExpireMonth] = useState("")
    const [card_expiry_year, setExpireYear] = useState("")
    const [loader, setLoader] = useState(false);
    const [monthError, setMonthError] = useState(false)
    const [month2Error, setMonth2Error] = useState(true)
    const [yearError, setYearError] = useState(false)
    const [year2Error, setYear2Error] = useState(true)
    const [cvcError, setCvcError] = useState(false)
    const [cvc2Error, setCvc2Error] = useState(true)
    const [disable, setDisable] = useState(true);
    const [isViewLoading, setIsViewLoading] = useState(true);
    const [showSaveCardsList, setShowSaveCardsList] = useState(false);
    const [newCard, setNewCard] = useState(false);
    const search: any = useLocation().search;
    const { t } = useTranslation();

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        let temp_order_id: any = params.get('temp_order_number') ? params.get('temp_order_number') : "123";
        let customer_token: any = params.get('customer_token') ? params.get('customer_token') : null;
        let token_id: any = params.get('token_id') ? params.get('token_id') : null;
        setTempOrderID(temp_order_id);
        setCustomerToken(customer_token);
        setTokenId(token_id)

        if (customer_token) {
            props.getCustomerCardDetails(customer_token)
        }

        if(!token_id) {
            setNewCard(true);
            setIsViewLoading(false)
        }
        else {
            setNewCard(false);
            setShowSaveCardsList(true)
        }

    }, [])
    useEffect(() => {
        if(cardTokens && cardTokens.length > 0 && tokenId && tokenId !== "" && temp_order_id && temp_order_id !== "") {
            cardTokens && cardTokens.forEach((token: any) => {
                if(token.id == tokenId) {
                    let hblObj: any = {
                        bill_to_address_country: "PK",
                        card_expiry_date: `${card_expiry_month}-${card_expiry_year}`,
                        currency: "PKR",
                        card_number: card_number,
                        temp_order_id: temp_order_id,
                        card_token: token.payment_token
                    }
                    props.submitHBLFormDAta(hblObj,setLoader)
                }
            });
        }
    }, [cardTokens]) 
    useEffect(() => {
        const paramstoken = new URLSearchParams(search).get('token');
        if (paramstoken) {
            let decodedparams: any = jwtDecode(paramstoken)
            if (decodedparams.reason_code == "100") {
                toast.success(t("PAYMENT_SUCCESSFULLY_COMPLETED"), {
                    position: toast.POSITION.TOP_RIGHT,
                    hideProgressBar: true,
                    autoClose: 3000,
                });
                (window as any).ReactNativeWebView.postMessage(`SUCCESS::${decodedparams.req_reference_number}::${decodedparams.order_id}`);
            }
            // reason_code : 476 (decision: DECLINE)  (message: 'Payer could not be authenticated.',')  
            // req_customer_ip_address     req_reference_number

            // reason_code : 481 (decision: REJECT) due to CyberSource suspecious multiple requests from same IP  
            // req_customer_ip_address     req_reference_number

            // reason_code : 100  (decision: ACCEPT)   (message: 'Request was processed successfully.') 
            // req_customer_ip_address    req_reference_number

            // reason_code : 102 (decision: ERROR) (message: Request parameters are invalid or missing') req_customer_ip_address  ( invalid_fields: 'card_number')  
            //  req_reference_number
            if (decodedparams.invalid_fields) {
                (window as any).ReactNativeWebView.postMessage(`${decodedparams.message} (${decodedparams.invalid_fields})`);
            } else {
                if (decodedparams.reason_code !== "100") {
                    (window as any).ReactNativeWebView.postMessage(`${decodedparams.message}`);
                }
            }
        }
    }, [])
    const handleCardNumber = (e: any) => {
        const input = e.target.value;
        const cleanedInput = input.replace(/[^0-9]/g, '');
        let formattedInput = '';

        for (let i = 0; i < cleanedInput.length; i += 4) {
            formattedInput += cleanedInput.substr(i, 4) + '-';
        }

        formattedInput = formattedInput.replace(/-$/, '');
        if (cleanedInput.length <= 16) {
            if(cleanedInput.length == 16){
                if(cardTokens && cardTokens.length > 0) {
                    const isCardAlreadySaved = cardTokens.some((obj: any) => {
                        const firstSixDigits = obj.masked_card.substring(0, 6);
                        const lastFourDigits = obj.masked_card.substring(12, 16);
                        const cardFirstSix = cleanedInput.substring(0, 6);
                        const cardLastFour = cleanedInput.substring(12, 16);
                        return firstSixDigits == cardFirstSix && lastFourDigits == cardLastFour;
                    })
                    isCardAlreadySaved ? setCardError2(true) : setCardError2(false);
                }
            }
            else{
                setCardError2(false);
            }
            setCardNum(cleanedInput)
            setDisable(false)

        }
    }
    const handleCardCVN = (e: any) => {
        const input = e.target.value;
        const cleanedInput = input.replace(/[^0-9]/g, '');
        if (cleanedInput.length <= 3)
            setCVN(cleanedInput)
        if (cleanedInput.length < 3)
            setCvcError(true)
        else setCvcError(false)

        setCvc2Error(false);
    }
    const handleCardExpireYear = (e: any) => {
        const input = e.target.value;
        const cleanedInput = input.replace(/[^0-9]/g, '');
        if (cleanedInput.length <= 4)
            setExpireYear(cleanedInput)
        if (cleanedInput.length < 4)
            setYearError(true)
        else setYearError(false)

        setYear2Error(false);
    }
    const handleCardExpireMonth = (e: any) => {
        const input = e.target.value;
        const cleanedInput = input.replace(/[^0-9]/g, '');
        if (cleanedInput.length <= 2)
            setExpireMonth(cleanedInput)
        if (cleanedInput.length < 2)
            setMonthError(true)
        else setMonthError(false);

        setMonth2Error(false);
    }
    const submitForm = () => {
        setLoader(true)
        let hblObj: any = {
            bill_to_address_country: "PK",
            card_expiry_date: `${card_expiry_month}-${card_expiry_year}`,
            currency: "PKR",
            card_number: card_number,
            temp_order_id: temp_order_id,
            isSaveCard: isSaveCard,
            card_token: null,
        }
        props.submitHBLFormDAta(hblObj,setLoader)
    }
    const submitFormWithToken = () => {
        setLoader(true)
        let hblObj: any = {
            bill_to_address_country: "PK",
            card_expiry_date: `${card_expiry_month}-${card_expiry_year}`,
            currency: "PKR",
            card_number: card_number,
            temp_order_id: temp_order_id,
            card_token: CustomercardToken.payment_token
        }
        props.submitHBLFormDAta(hblObj,setLoader)
    }
    const images: any = {
        'Mastercard' : '/mastercard-logo.png',
        'Visa' : '/visa-logo.png'
    }
    const maskCardDigits = (number: any) => {
        const regex = /^\d{6}/;
        return number.replace(regex, 'xxxxxx');
    } 
    const handleCardSelectCheck = (obj: any) => {
        setCustomercardToken(obj)
    }
    const handleCardCheckboxChange = (e: any) => {
        setIsNewCard(!isNewCard)
        if(isNewCard) {
            setCustomercardToken({})
        }
        else {
            cardTokens && cardTokens.forEach((token: any) => {
                if(token.is_default == 1) {
                    setCustomercardToken(token)
                }
            });
            setCardNum("")
            setCVN("")
            setExpireMonth("")
            setExpireYear("")
            setCardError2(false)
            setCvcError(false)
            setMonthError(false)
            setYearError(false)
            setCvc2Error(true)
            setMonth2Error(true)
            setYear2Error(true)
            setDisable(true)
            setIsSaveCard(false)
        }
    }
    const handleSaveCheckboxChange = (e: any) => {
        setIsSaveCard(!isSaveCard)
    }
    return (
        <>
            {
                isViewLoading ? 
                    <WebViewLoader/> 
                : 
                <div className='payment-cotainer'>
                    <div className='kfc-order'>
                        <div className="container-xxl category-container-custom mt-4 mb-md-100">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className='payment-method'>
                                        <h3 className='mt-3 px-1 font-bold'>{t("CARD_PAYMENT")}</h3>
                                        {
                                            newCard ?
                                            <form id="payment_confirmation" action="https://secureacceptance.cybersource.com/silent/pay" method="post" >
                                                {(hblFormData) && Object.keys(hblFormData).map((key, index) => {
                                                    return <input key={index} type="hidden" name={key} value={hblFormData[key]} />
                                                })}
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-md-6 mt-4">
                                                                <TextField name="card_number" type='text' className='field-style' id="card_number"
                                                                    helperText={cardError2 ? t("CARD_IS_ALREADY_SAVED") : ""}
                                                                    onChange={handleCardNumber}
                                                                    inputProps={{
                                                                        inputMode: 'numeric',
                                                                        pattern: '[0-9]*',
                                                                    }}
                                                                    value={card_number} label={<div className='font-normal d-flex gap-1'><p>{t("CARD_NUMBER")}</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error" />
                                                            </div>
                                                            <div className="col-md-6 mt-4">
                                                                <TextField
                                                                    helperText={monthError ? t("MONTH_MUST_BE_OF") : ""}
                                                                    inputProps={{
                                                                        inputMode: 'numeric',
                                                                        pattern: '[0-9]*',
                                                                    }}
                                                                    placeholder='MM' type='text' className='field-style' onChange={handleCardExpireMonth} value={card_expiry_month} label={<div className='font-normal d-flex gap-1'><p>{t("EXPIRY_MONTH")}</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error" />
                                                            </div>
                                                            <div className="col-md-6 mt-4">
                                                                <TextField
                                                                    helperText={yearError ? t("YEAR_MUST_BE_OF_4_DIGIT") : ""}
                                                                    inputProps={{
                                                                        inputMode: 'numeric',
                                                                        pattern: '[0-9]*',
                                                                    }}
                                                                    placeholder='YYYY' type='text' className='field-style' onChange={handleCardExpireYear} value={card_expiry_year} label={<div className='font-normal d-flex gap-1'><p>{t("EXPIRY_YEAR")}</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error" />
                                                            </div>
                                                            <div className="col-md-6 mt-4">
                                                                <TextField
                                                                    helperText={cvcError ? t("CVC_MUST_BE_OF_3_DIGIT") : ""}
                                                                    inputProps={{
                                                                        inputMode: 'numeric',
                                                                        pattern: '[0-9]*',
                                                                    }}
                                                                    name="card_cvn" type='text' className='field-style' id="card_cvn" onChange={handleCardCVN} value={cvn} label={<div className='font-normal d-flex gap-1'><p>{t("CARD_CVC")}</p><p className='color-theme h4'>*</p></div>} variant="filled" color="error" />
                                                            </div>
                                                            {/* <div className='mt-3 ms-1'>
                                                                    <FormGroup>
                                                                        <FormControlLabel 
                                                                            className='color-white'
                                                                            control={
                                                                                <Checkbox 
                                                                                    checked={isSaveCard} 
                                                                                    onChange={handleSaveCheckboxChange} 
                                                                                    inputProps={{ "aria-label": "controlled" }} 
                                                                                    className='color-theme' 
                                                                                />
                                                                            } 
                                                                            label="Save Card Details" 
                                                                        />
                                                                    </FormGroup>
                                                            </div> */}
                                                        </div>
                                                        <div className='d-flex justify-content-between gap-10 mb-4'>
                                                            {loader ?
                                                                <Button className='w-50 m-auto d-flex mt-4 bg-theme' variant="contained" color="error">{<CircularProgress size={25} color={"inherit"} />}</Button> :
                                                                <Button onClick={() => {
                                                                    submitForm()
                                                                }} disabled={((disable || cvcError || monthError || yearError || cvc2Error || month2Error || year2Error || cardError2)) ? true : false}
                                                                    className={`${(disable || cvcError || monthError || yearError || cvc2Error || month2Error || year2Error || cardError2) ? "disable-btn" : "able-btn"} w-50 m-auto d-flex mt-4 bg-theme`} variant="contained" color="error">{t("MAKE_PAYMENT")}</Button>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                            :
                                            null
                                        }
                                        {
                                            showSaveCardsList ?
                                            <div>
                                                <FormControl className='w-100 address-container mt-2'>
                                                    <RadioGroup
                                                        aria-labelledby="demo-radio-buttons-group-label"
                                                        name="radio-buttons-group"
                                                    >
                                                        {
                                                            cardTokens && cardTokens
                                                            .sort((a: any, b: any) => {
                                                                if(a.is_default == b.is_default){
                                                                    return 0;
                                                                }
                                                                return a.is_default ? -1 : 1;
                                                            })
                                                            .map((obj: any, index: any) => {
                                                                return (
                                                                    <div className='save-cards'>
                                                                        <FormControlLabel 
                                                                            control={ <Radio className='color-theme' /> } 
                                                                            name="radio-buttons-online-cards"
                                                                            onClick={()=>{handleCardSelectCheck(obj)}}
                                                                            checked={CustomercardToken && CustomercardToken.payment_token == obj.payment_token}
                                                                            label={
                                                                                <div className='d-flex align-items-center gap-10'>
                                                                                    <img src={images[obj.card_type]} alt={obj.card_type} className='payment-card-image' />
                                                                                    <span>{maskCardDigits(obj.masked_card)}</span>
                                                                                </div>
                                                                            } 
                                                                        />
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </RadioGroup>
                                                </FormControl>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
            <form id="token_payment_confirmation" action="https://secureacceptance.cybersource.com/silent/pay" method="post" >
                {(hblFormData) && Object.keys(hblFormData).map((key) => {
                    return <input type="hidden" name={key} value={hblFormData[key]} />
                })}
            </form>
        </>
    )
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        submitHBLFormDAta: function (data: any,setLoader:any) {
            dispatch(submitHBLFormDAta(data,setLoader));
        },
        getCustomerCardDetails: (customer_token: any) => {
            dispatch(MobilecardDetails(customer_token))
        },
    };
};
export default connect(null, mapDispatchToProps)(MobileCardPayment);